/**
 * Generated report viewer component.
 */
interface ReportViewerProps {
  report: string
  tokensUsed?: number | null
  modelUsed?: string
  reasoningEffort?: string | null
  samplesUsed?: number
}

export const ReportViewer: React.FC<ReportViewerProps> = ({
  report,
  tokensUsed,
  modelUsed,
  reasoningEffort,
  samplesUsed,
}) => {
  return (
    <div className="card">
      <div className="flex justify-between items-start mb-4">
        <h2 className="text-2xl font-bold text-gray-900">Generated Report</h2>

        {/* Metadata */}
        {(tokensUsed || modelUsed) && (
          <div className="text-sm text-gray-500 text-right">
            {modelUsed && (
              <div>
                Model: <span className="font-semibold">{modelUsed}</span>
                {reasoningEffort && (
                  <span className="ml-2">({reasoningEffort} reasoning)</span>
                )}
              </div>
            )}
            {tokensUsed && <div>Tokens: {tokensUsed.toLocaleString()}</div>}
            {samplesUsed !== undefined && samplesUsed > 0 && (
              <div className="text-primary-600">
                ✓ Used {samplesUsed} training sample{samplesUsed !== 1 ? 's' : ''}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Report Content */}
      <div className="prose prose-sm max-w-none">
        <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
          <pre className="whitespace-pre-wrap font-sans text-gray-800 leading-relaxed">
            {report}
          </pre>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
        <p className="text-sm text-amber-800">
          ⚠️ <strong>AI-Generated Report:</strong> This report was automatically generated from
          your meeting notes. Please verify critical information before making decisions based on
          this content.
        </p>
      </div>
    </div>
  )
}
